import React from 'react';
import { useStyles } from './SwitchCardsView.styles';
import { ReactComponent as CardsIcon } from '../../../assets/icons/card.svg';
import { ReactComponent as SolutionsIcon } from '../../../assets/icons/solution.svg';
import { ReactComponent as CardsIconHover } from '../../../assets/icons/card-hover.svg';
import { ReactComponent as SolutionsIconHover } from '../../../assets/icons/solution-hover.svg';
import { SwitchCards, cardDefinition } from './../../SwitchCards/SwitchCards.component';
import SolutionCard from '../../../pages/SolutionCard/SolutionCard.component';
import { fill, fillBlue } from '../../../utils/contrastSvgAttributes';

interface SwitchCardsViewProps {
  viewType: 'cards' | 'solutions';
  handleSwitchView: (type: 'cards' | 'solutions') => void;
}

export const SwitchCardsView: React.FC<SwitchCardsViewProps> = (props) => {
  const classes = useStyles();

  const cards = [
    {
      id: 'cards',
      caption: 'Karty',
      activeIcon: <CardsIcon className={classes.switchViewIcon} title="ikona kart aktywna" fill={fillBlue} />,
      inactiveIcon: <CardsIconHover className={classes.switchViewIcon} fill={fillBlue} />,
    },
    {
      id: 'solutions',
      caption: 'Zadania',
      activeIcon: <SolutionsIcon fill={fillBlue} className={classes.switchViewIcon} title="ikona zadań aktywna" />,
      inactiveIcon: (
        <SolutionsIconHover className={classes.switchViewIcon} fill={fillBlue} title="ikona zadań nieaktywna" />
      ),
    },
  ];

  const onSwithCard = (card: cardDefinition) => {
    props.handleSwitchView(card.id as 'cards' | 'solutions');
  };

  return (
    <SwitchCards
      className={classes.switchViewOutline}
      cards={cards}
      activeCardId={props.viewType}
      onSwitchView={onSwithCard}
    />
  );
};
